<template>
  <v-row>
    <v-col>

      <v-sheet
        outlined
        rounded 
        class="ma-2"
        v-if="show">

        <v-row class="pa-8 d-flex justify-center">

          <div
            v-for="type_sponsor in types_sponsors"
            v-bind:key="type_sponsor.id">

            <v-row v-if="type_sponsor.is_visible">
              <v-col cols="12">
                <h4 class="font-weight-regular text-center pt-1">{{ type_sponsor.name }}:</h4>
              </v-col>

              <v-col 
                v-for="sponsor in type_sponsor.sponsors" 
                :key="sponsor.id"
                class="d-flex align-center justify-center">

                <a :href="sponsor.web" target="_blank">
                  <v-img
                      v-bind:src="sponsor.url_logo"
                      max-height="44px"
                      max-width="118px"
                      contain
                      class="ma-1"
                    />
                </a>
              </v-col>
            </v-row>

          </div>
        </v-row>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'cardFeaturedSponsorsSM',
    props:['types_sponsors'],

    data: () => ({
      show: false,
      url_logo:null,
      base_url: null
    }),

    methods:{
      setData(){
        this.types_sponsors.forEach(types_sponsor => {
          types_sponsor.sponsors.forEach(sponsor => {
            sponsor.url_logo = APP_URL + sponsor.url_logo
          })
        });
        this.show = true
      }
    },
    created() {
      this.setData()
    }
  }
</script>

<style type='text/css' scoped>

.v-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 4px; /* Espacio entre filas */
}

.v-img {
  max-width: 100%; /* Asegura que la imagen no se extienda más allá de su contenedor */
  height: auto; /* Ajusta la altura automáticamente */
}

.card {
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.zoom-sponsor{
  zoom: 1;
}
</style>